// Compatibility hook — combines InvoQuote's real AuthContext + UserContext
// into the { currentUser, tenantId, profileDocId, isSuperAdmin } shape that
// the lifted T&C/deletion components (from ov-audit) expect from `useAuth()`.
import { useAuth as useFirebaseAuth } from '../AuthContext';
import { useUserContext } from '../components/context/UserContext';
import { getSuperAdminEmails } from '../utils/superAdminEmails';

export function useLegalAuth() {
  const { currentUser } = useFirebaseAuth();
  const { userProfile, profileDocId, profileLoaded } = useUserContext();

  const isSuperAdmin = !!(
    currentUser?.email &&
    getSuperAdminEmails().includes(currentUser.email.trim().toLowerCase())
  );

  return {
    currentUser,
    tenantId: userProfile?.tenantId || null,
    profileDocId,
    profileLoaded,
    isSuperAdmin,
  };
}
